import React from 'react';
import PropTypes from 'prop-types';

import {Button} from 'views/components';

import {translate} from 'views/module';

import AuthenticateUserDialog from '../dialogs/AuthenticateUserDialog';
import ConfirmDialog from '../dialogs/ConfirmDialog';

const ClientAuthentication = (props) => {
  const {clientBackend, relationshipData, userIdentity} = props;
  const [isLoading, setIsLoading] = React.useState(false);
  const [showDialog, setShowDialog] = React.useState(false);
  const [showConfirmDialog, setShowConfirmDialog] = React.useState(false);
  const [confirmAction, setConfirmAction] = React.useState(null);
  const [confirmDialogProps, setConfirmDialogProps] = React.useState({});
  const [form, setForm] = React.useState({
    email: '',
    firstName: '',
    lastName: '',
  });

  const deactivateUser = async () => {
    setIsLoading(true);
    clientBackend.user.deactivateUser(relationshipData.relationshipRn, () => setIsLoading(false));
  };

  const reactivateUser = async () => {
    setIsLoading(true);
    await clientBackend.user.reactivateUser(relationshipData.relationshipRn, () => setIsLoading(false));
  };

  const handleOpenDialog = () => {
    const email = userIdentity.email.trim();
    const fullName = relationshipData.name || '';
    const firstName = fullName.split(' ')[0] || '';
    const lastName = fullName.split(' ').slice(1).join(' ') || '';
    setForm({email, firstName, lastName});
    setShowDialog(true);
  };
  const handleConfirm = async () => {
    if (confirmAction) {
      await confirmAction();
    }
    setShowConfirmDialog(false);
  };
  const getButtonConfig = () => {
    if (userIdentity?.status === 'ACTIVE') {
      return {
        text: translate('client.ClientDetail.Relationships.Contacts.States.Active'),
        action: () => {
          setConfirmDialogProps({
            title: translate('client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmDeactivate.Title'),
            message: translate('client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmDeactivate.Message'),
            confirmText: translate('client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmDeactivate.ConfirmButton'),
          });
          setConfirmAction(() => deactivateUser);
          setShowConfirmDialog(true);
        },
      };
    } else if (userIdentity?.status === 'INACTIVE') {
      return {
        text: translate('client.ClientDetail.Relationships.Contacts.States.Reactivate'),
        action: () => {
          setConfirmDialogProps({
            title: translate('client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmReactivate.Title'),
            message: translate('client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmReactivate.Message'),
            confirmText: translate('client.ClientDetail.Relationships.Contacts.Dialogs.ConfirmReactivate.ConfirmButton'),
          });
          setConfirmAction(() => reactivateUser);
          setShowConfirmDialog(true);
        },
      };
    } else if (userIdentity?.status === 'NOT_SET_UP') {
      return {text: translate('client.ClientDetail.Relationships.Contacts.States.Setup'), action: handleOpenDialog};
    } else {
      return;
    }
  };

  const buttonConfig = getButtonConfig();
  if (!buttonConfig) {
    return null;
  }
  return (
    <>
      <Button
        onClick={buttonConfig.action}
        variant="contained"
        size="small"
        disabled={isLoading}
        sx={{color: 'color.white'}}
      >
        {buttonConfig.text}
      </Button>
      {
        showDialog &&
        <AuthenticateUserDialog
          open={showDialog}
          onClose={() => setShowDialog(false)}
          onSubmit={(data) => {
            clientBackend.user.createUser({
              ...data,
              clientRelationshipRn: relationshipData.relationshipRn,
            });
            setShowDialog(false);
          }}
          initialData={form}
          isLoading={isLoading}
        />
      }
      {
        showConfirmDialog &&
        <ConfirmDialog
          open={showConfirmDialog}
          title={confirmDialogProps.title}
          message={confirmDialogProps.message}
          onCancel={() => setShowConfirmDialog(false)}
          onConfirm={handleConfirm}
          confirmText={confirmDialogProps.confirmText}
          cancelText={translate('client.ClientDetail.Relationships.Contacts.Dialogs.Cancel')}
          isLoading={isLoading}
        />
      }
    </>
  );
};

ClientAuthentication.propTypes = {
  clientBackend: PropTypes.object.isRequired,
  relationshipData: PropTypes.object.isRequired,
  userIdentity: PropTypes.shape({
    email: PropTypes.string.isRequired,
    status: PropTypes.string,
  }).isRequired,
};

export default ClientAuthentication;
